export default async ({ store, redirect }) => {
  if (store.state.global.loggedIn) {
    if (!store.state.global.user.is_passworded) {
      redirect('/user/create-password');
    }
  }
};
